export default __webpack_public_path__ + "static/media/eye_off_icon.cc8d270f.svg";